// src/components/pages/ViewAllSubmissionContributionsPage.js

import React, { useEffect, useState } from "react";
import { Container, Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "styled-components";
import { fetchHoldings } from "../../services/submissionService";
import ViewAllHoldingsSection from "../organisms/ViewAllHoldingsSection";

const ViewAllSubmissionContributionsPage = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [holdings, setHoldings] = useState([]);

  useEffect(() => {
    const getHoldings = async () => {
      try {
        // 1. Call the new API function
        const data = await fetchHoldings();

        // 2. Destructure the holdings array from the response
        const { holdings } = data;
        setHoldings(holdings);

        console.log("Holdings from API:", holdings);
      } catch (err) {
        console.error("Error fetching holdings:", err);
        setError(err.message || "An error occurred while fetching holdings.");
      } finally {
        setLoading(false);
      }
    };

    getHoldings();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <CircularProgress
            sx={{
              color: theme.colors.red,
            }}
          />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Box>
        <ViewAllHoldingsSection
          header="My Purchases & Contributions"
          holdings={holdings}
          theme={theme}
        />
      </Box>
    </Container>
  );
};

export default ViewAllSubmissionContributionsPage;
